import * as R from 'ramda';

export const cohortsWithSessionsFlag = [
  '675815a4cb0f1f002b1f16b2',
  '675815c1dd1c12002ba3d38a',
  '6798a35e895db0002bab9819',
  '68821ef3c14da1002bb436e7',
  '68821fb986c394002b8df83a',
  '6841b27151c9e3002b7aa195',
];

export const hasDoubleSessions = (cohort) => {
  const sessions = Number(R.prop('sessions', cohort));
  if (sessions === 2) return true;
  if (sessions === 1) return false;

  return (
    R.propEq('format', 'ft', cohort) ||
    R.includes(R.prop('id', cohort), cohortsWithSessionsFlag)
  );
};
